export default "__VITE_ASSET__DGjsnKYz__"